import { Badge } from '@/components/ui/badge'
import type { CustomerType } from '@/types'
import { cn } from '@/lib/utils'

interface CustomerTypeBadgeProps {
  type: CustomerType
  className?: string
}

const TYPE_CONFIG: Record<CustomerType, { label: string; className: string }> = {
  MEDICAL: {
    label: 'Medical',
    className:
      'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400 border-blue-200 dark:border-blue-800',
  },
  RECREATIONAL: {
    label: 'Rec',
    className:
      'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400 border-green-200 dark:border-green-800',
  },
  BOTH: {
    label: 'Both',
    className:
      'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400 border-purple-200 dark:border-purple-800',
  },
}

export function CustomerTypeBadge({ type, className }: CustomerTypeBadgeProps) {
  const { label, className: colorClass } = TYPE_CONFIG[type]
  return (
    <Badge variant="outline" className={cn('text-xs font-medium', colorClass, className)}>
      {label}
    </Badge>
  )
}
